export { default } from './TermsConditionsScreen';
export * from './TermsConditionsScreen';
